import React from 'react'
import { addAdminToogle } from '../redux/slices/adminToogle'
import { useSelector, useDispatch } from 'react-redux';
import { Col, Container, Row } from "react-bootstrap";
import { Menu } from 'react-feather';
import { Search } from 'react-feather';
import { MessageCircle } from 'react-feather';
import { Bell } from 'react-feather';

const AdminHeaderSection = () => {
  const dispatch = useDispatch()
  const showLeftSideBar = useSelector(state => state.adminToogle.adminToogleAction)
  const handleMenuShow = () => {
    dispatch(addAdminToogle({
      adminToogleAction: !showLeftSideBar,
      transitionTime: 1000
    }))

  }
  return (
    <>
      <Container>
        <Row>
          <Col xs={12}>
            <div className='menuTopWrap'>
              <div onClick={handleMenuShow} className="menuIconAdmin">
                <Menu />
              </div>
              <div className='menuRightSideIcon'>
                <ul>
                  <li>
                    <Search />
                  </li>
                  <li>
                    <MessageCircle />
                  </li>
                  <li>
                    <Bell />
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

    </>
  )
}

export default AdminHeaderSection